/**
 * Stripe instance and Elements options for checkout.
 * Same behavior as previous useMemo in checkout-page.
 */
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { useState, useEffect, useMemo } from 'react';

import * as api from '../../../../shared/services/apiClient';

export function useCheckoutStripe(clientSecret: string | null) {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);

  useEffect(() => {
    const initStripe = async () => {
      try {
        let pk = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

        if (!pk) {
          const res = await api.get('/api/payment/config');
          const data = await res.json();
          pk = data.publishableKey;
        }

        if (pk) {
          setStripePromise(loadStripe(pk));
        }
      } catch (err) {
        console.error(err);
      }
    };

    initStripe();
  }, []);

  const elementsOptions = useMemo(
    () => (clientSecret ? { clientSecret } : {}),
    [clientSecret]
  );

  return { stripePromise, elementsOptions };
}
